/**
 * Does this failed API response mean "your login is no longer valid"?
 *
 * 401 is the obvious case. But the backend answers a missing/expired/invalid token on a protected endpoint with a bare
 * 403 (empty body), not 401. Real "not allowed" answers (wrong order, unverified e-mail, ...) are also 403 but always
 * carry a JSON body with an errorCode — so an empty 403 on a request that carried a token is a dead session too.
 */
export const isSessionExpiredResponse = (error) => {
  const res = error?.response;
  if (!res) return false;
  if (res.status === 401) return true;
  if (res.status !== 403) return false;

  const sentToken = Boolean(error?.config?.headers?.Authorization);
  const data = res.data;
  const emptyBody = data == null || data === '' || (typeof data === 'object' && Object.keys(data).length === 0);
  return sentToken && emptyBody;
};
